import React, { useState } from 'react';
import { PageProps } from 'gatsby';
import Button from 'atoms/Button/Button';
import { IMenuLink } from './HeaderLinks';
import Stack from 'atoms/Layout/Stack/Stack';
import Clickable from 'atoms/Clickable/Clickable';
import MightyLogo from 'src/app/icons/Custom/Logos/Mighty/Mighty';
import { BreakpointType } from 'atoms/Layout/Visibility.styles';
import Menu01 from 'app/icons/Monospaced/Menu/Menu01';
import XClose from 'app/icons/Monospaced/X/XClose';
import SideNav from 'molecules/SideNav/SideNav';
import { useHeaderCustomization } from 'src/hooks/useHeaderCustomization';

interface HeaderMobileProps {
  isPro: boolean;
  showOn: BreakpointType;
  sideBarLinks: IMenuLink[];
  locationProps: PageProps['location'];
}

const HeaderMobile = ({ isPro, showOn, sideBarLinks, locationProps }: HeaderMobileProps): JSX.Element => {
  const [isSideNavOpen, setIsSideNavOpen] = useState(false);
  const { links: customLinks, hideSideBar = false } = useHeaderCustomization();

  const links = customLinks ?? sideBarLinks;

  const handleMenuClick = () => {
    setIsSideNavOpen(!isSideNavOpen);
  };

  return (
    <Stack
      align='center'
      showOn={showOn}
      direction='row'
      justify='space-between'
      gap={'spacing-2xl'}
      className='header-content'
    >
      <Clickable href='/'>
        <MightyLogo width={103.758} />
      </Clickable>
      {!hideSideBar && (
        <Stack
          direction='row'
          dataCy='mobile-menu-button'
        >
          <Button
            size='lg'
            icon={isSideNavOpen ? <XClose /> : <Menu01 />}
            variant='text-link'
            onClick={handleMenuClick}
          />
        </Stack>
      )}
      <SideNav
        isPro={isPro}
        isOpen={isSideNavOpen}
        sideBarLinks={links}
        locationProps={locationProps}
      />
    </Stack>
  );
};

export default HeaderMobile;
